import React, { Component } from "react";
import moment from "moment";
import { AkProfilecard } from "@atlaskit/profilecard";

import "./listingPreviewCard.css";
export default class ListingPreviewCard extends Component {
  render() {
    const data = this.props.data || {};
    const actions = this.props.actions || [];
    const location = data.location || {};
    return (
      <div className="listing-preview-container">
        <AkProfilecard
          location={
            location ? `${location.city}, ${location.province}` : undefined
          }
          presence={data.presence}
          presenceMessage={data.presenceMessage}
          style={{ maxWidth: "100%" }}
          fullName={data.title}
          meta={data.lid}
          nickname={data.twitter || data.facebook || data.linkedIn}
          email={data.description}
          className="application__profile-card"
          avatarUrl={`data:image/jpeg;base64,${data.preview}`}
          timestring={
            data.listingDate
              ? moment(data.listingDate._seconds * 1000).format("MMM Do")
              : ""
          }
          actions={
            actions
              ? actions.map(i => ({
                  label: i.label,
                  id: i.id,
                  callback: i.callback
                }))
              : null
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListingPreviewCard/ListingPreviewCard.js